import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';

import { BIG_TEXT_FOREGROUND, BIG_TEXT_MUTED } from './bigBarStyle';

interface DashboardBreadcrumbsProps {
    title: string;
    tab: string;
}

export function DashboardBreadcrumbs({
    title,
    tab
}: DashboardBreadcrumbsProps) {
    return (
        <nav aria-label="Breadcrumb" className="min-w-0">
            <ol className="flex flex-nowrap items-center gap-1.5 sm:gap-2.5 min-w-0 text-sm">
                <li
                    className={cn(
                        'max-w-[12.5rem] sm:max-w-[18.75rem] truncate',
                        tab ? BIG_TEXT_MUTED : BIG_TEXT_FOREGROUND
                    )}
                >
                    {title}
                </li>
                {tab && (
                    <>
                        <li
                            aria-hidden="true"
                            className={cn('shrink-0', BIG_TEXT_MUTED)}
                        >
                            <ChevronRight className="w-4 h-4" />
                        </li>
                        <li
                            aria-current="page"
                            className={cn(
                                'max-w-[9.375rem] sm:max-w-[12.5rem] truncate',
                                BIG_TEXT_FOREGROUND
                            )}
                        >
                            {tab}
                        </li>
                    </>
                )}
            </ol>
        </nav>
    );
}
